import type {TFunction} from "i18next";
import {humanizeToolField} from "@repo/ui/gailgpt/tool-presentation";
import {getTranslatedNodeDefinitionLabel, NODE_REGISTRY} from "@/components/workflows/utils/helpers/workflow-node-registry";

/** Generated names describe identity, not what a step does. Keep them in configuration only. */
export function workflowNodePresentation(node: {id: string; type: string; name?: string}, t: TFunction<"workflows">) {
   const registered = Object.hasOwn(NODE_REGISTRY, node.type) ? NODE_REGISTRY[node.type] : undefined;
   const definition = registered ? {type: node.type, ...registered} : undefined;
   const typeLabel = registered ? getTranslatedNodeDefinitionLabel(node.type, t) : humanizeToolField(node.type);
   const name = node.name?.trim();
   const generated = name === node.id || name === node.type;
   return {definition, typeLabel, name: name && !generated ? name : typeLabel};
}
